import { useMemo, useState } from "react";
import { findWorkReview } from "../../slices/works-slice";
import { NotificationDTO } from "../../domain/models/dto/NotificationDTO";
import { NotificationType } from "../../domain/enums/NotificationTypeEnum";

const useCurrentReview = (notification: NotificationDTO) => {
    const [isModalVisible, setModalVisible] = useState(false);

    const isEmployeeReview = useMemo(
        () => notification.type === NotificationType.EMPLOYEE_REVIEW_CREATE,
        [notification]
    );

    const subject = useMemo(
        () =>
            isEmployeeReview
                ? notification.application.work.client
                : notification.application.user,
        [notification]
    );
    const currentReview = useMemo(
        () =>
            findWorkReview(subject?.id, notification.application.work.reviews),
        [notification]
    );

    return {
        isEmployeeReview,
        subject,
        currentReview,
        isModalVisible,
        setModalVisible,
    };
};

export default useCurrentReview;
